// TODO: check if this widget is still in use
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { RelatedCategoriesTableWidget } from "./RelatedCategoriesTableWidget";
import { WidgetState } from "./Widget";

export class CustomCategoriesWidget extends RelatedCategoriesTableWidget {
    public static getWidgetMetadataType() {
        return "CustomCategoriesTable";
    }

    public static getWidgetResourceType() {
        return "Table";
    }

    private emptyWidget = false;
    private showCustomCategoriesModal = false;

    public initWidget(widgetConfig, context) {
        super.initWidget(widgetConfig, context);
        const customCategories = UserCustomCategoryService.getCustomCategories();
        if (customCategories.length < 2) {
            this.emptyWidget = true;
        }
    }

    public getData() {
        if (!this.emptyWidget) {
            return super.getData();
        } else {
            this.widgetState = WidgetState.LOADED;
            return Promise.resolve();
        }
    }

    public setMetadata() {
        if (!this.emptyWidget) {
            super.setMetadata();
        }
    }

    public callbackOnGetData(response: any) {
        if (!this.emptyWidget) {
            super.callbackOnGetData(response);
        }
    }

    public onResize() {
        super.onResize();
    }

    public validateData(response: any) {
        if (!this.emptyWidget) {
            return super.validateData(response);
        } else {
            return true;
        }
    }

    public getWidgetModel() {
        return Object.assign(super.getWidgetModel(), { type: "CustomCategories" });
    }

    public openCustomCategoriesWizard() {
        this.showCustomCategoriesModal = true;
    }

    public onClose = () => {
        this.showCustomCategoriesModal = false;
        this.notifyWidgetUpdated();
    };

    public canAddToDashboard() {
        return false;
    }

    // This method is invoked Only when widget is in dashboard context
    protected addCategoryLink(row) {
        Object.assign(row, { isCustomCategory: true });
        super.addCategoryLink(row);
    }

    get templateUrl() {
        if (!this.emptyWidget) {
            return `/app/components/widget/widget-templates/table.html`;
        } else {
            return `/app/components/widget/widget-templates/customcategories.html`;
        }
    }

    get templateComponent() {
        if (!this.emptyWidget) {
            return TableTemplateV2;
        } else {
            console.error(
                "in CustomCategoriesWidget, should show /app/components/widget/widget-templates/customcategories.html",
            );
            return null;
        }
    }
}

CustomCategoriesWidget.register();
